import React from "react";
import PropTypes from "prop-types";
import MoreVertIcon from "@mui/icons-material/MoreVert";
import AddIcon from "@mui/icons-material/Add";
import KeyboardArrowUpIcon from "@mui/icons-material/KeyboardArrowUp";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import LanguageIcon from "@mui/icons-material/Language";
import CloseIcon from "@mui/icons-material/Close";
import ArrowRightAltIcon from "@mui/icons-material/ArrowRightAlt";
import NotificationsTwoToneIcon from "@mui/icons-material/NotificationsTwoTone";
import CheckBoxIcon from "@mui/icons-material/CheckBox";
import CheckBoxOutlineBlankIcon from "@mui/icons-material/CheckBoxOutlineBlank";
import HelpOutlineIcon from "@mui/icons-material/HelpOutline";
import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined";
import SearchIcon from "@mui/icons-material/Search";
import OpenInNewIcon from "@mui/icons-material/OpenInNew";
import DownloadIcon from "@mui/icons-material/Download";
import PlaylistAddIcon from "@mui/icons-material/PlaylistAdd";
import DeleteIcon from "@mui/icons-material/Delete";
import EditIcon from "@mui/icons-material/Edit";
import MenuIcon from "@mui/icons-material/Menu";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import ArrowForwardIcon from "@mui/icons-material/ArrowForward";
import MoreHorizIcon from "@mui/icons-material/MoreHoriz";
import RemoveIcon from "@mui/icons-material/Remove";
import KeyboardArrowLeftIcon from "@mui/icons-material/KeyboardArrowLeft";
import KeyboardArrowRightIcon from "@mui/icons-material/KeyboardArrowRight";
import SubdirectoryArrowRightIcon from "@mui/icons-material/SubdirectoryArrowRight";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import ErrorIcon from "@mui/icons-material/Error";
import InfoIcon from "@mui/icons-material/Info";
import WarningIcon from "@mui/icons-material/Warning";
import WarningAmberIcon from "@mui/icons-material/WarningAmber";
import CheckOutlinedIcon from "@mui/icons-material/CheckOutlined";
import Check from "@mui/icons-material/Check";
import DashboardOutlinedIcon from "@mui/icons-material/DashboardOutlined";
import InsertChartTwoToneIcon from "@mui/icons-material/InsertChartTwoTone";
import ListAltTwoToneIcon from "@mui/icons-material/ListAltTwoTone";
import SettingsTwoToneIcon from "@mui/icons-material/SettingsSharp";
import HelpOutlineOutlinedIcon from "@mui/icons-material/HelpOutlineOutlined";
import PieChartIcon from "@mui/icons-material/PieChart";
import WorkIcon from "@mui/icons-material/Work";
import BuildIcon from "@mui/icons-material/Build";
import HomeWorkIcon from "@mui/icons-material/HomeWork";
import TextSnippetIcon from "@mui/icons-material/TextSnippet";
import FileOpenIcon from "@mui/icons-material/FileOpen";
import NavigateNext from "@mui/icons-material/NavigateNext";
import DeleteForeverIcon from "@mui/icons-material/DeleteForever";
import TrendingDownIcon from "@mui/icons-material/TrendingDown";
import TrendingUpIcon from "@mui/icons-material/TrendingUp";
import SettingsSharpIcon from "@mui/icons-material/SettingsSharp";
import NewReleasesIcon from "@mui/icons-material/NewReleases";
import ArrowRightIcon from "@mui/icons-material/ArrowRight";
import IndeterminateCheckBoxIcon from "@mui/icons-material/IndeterminateCheckBox";
import PlaylistAddCheckIcon from "@mui/icons-material/PlaylistAddCheck";
import CategoryIcon from "@mui/icons-material/Category";
import InsightsIcon from "@mui/icons-material/Insights";
import AssessmentOutlinedIcon from "@mui/icons-material/AssessmentOutlined";
import BackupTableIcon from "@mui/icons-material/BackupTable";
import FullscreenIcon from "@mui/icons-material/Fullscreen";
import FullscreenExitIcon from "@mui/icons-material/FullscreenExit";
import UpgradeIcon from "@mui/icons-material/Upgrade";
import PeopleIcon from "@mui/icons-material/People";
import AutorenewIcon from "@mui/icons-material/Autorenew";
import UploadIcon from "@mui/icons-material/Upload";
import LocationCityIcon from "@mui/icons-material/LocationCity";
import HighlightOffIcon from "@mui/icons-material/HighlightOff";
import SignalCellularAltIcon from "@mui/icons-material/SignalCellularAlt";
import BubbleChartIcon from "@mui/icons-material/BubbleChart";
import FilterAltIcon from "@mui/icons-material/FilterAlt";
import FilterAltOutlinedIcon from "@mui/icons-material/FilterAltOutlined";
import TableChartIcon from "@mui/icons-material/TableChart";
import DoDisturbIcon from "@mui/icons-material/DoDisturb";
import BarChartIcon from "@mui/icons-material/BarChart";
import ClearIcon from "@mui/icons-material/Clear";
import AccountTreeRoundedIcon from "@mui/icons-material/AccountTreeRounded";
import ArrowDownwardIcon from "@mui/icons-material/ArrowDownward";
import ArrowUpwardIcon from "@mui/icons-material/ArrowUpward";
import ArrowDropDownIcon from "@mui/icons-material/ArrowDropDown";
import CancelTwoToneIcon from "@mui/icons-material/CancelTwoTone";
import SwapHorizIcon from "@mui/icons-material/SwapHoriz";
import WarningRoundedIcon from "@mui/icons-material/WarningRounded";
import WarningAmberRoundedIcon from "@mui/icons-material/WarningAmberRounded";
import ContentCopyIcon from "@mui/icons-material/ContentCopy";
import StarRoundedIcon from "@mui/icons-material/StarRounded";
import StarBorderRoundedIcon from "@mui/icons-material/StarBorderRounded";
import StickyNote2Outlined from "@mui/icons-material/StickyNote2Outlined";
import HistoryIcon from "@mui/icons-material/History";
import MergeTypeIcon from "@mui/icons-material/MergeType";
import RemoveCircleIcon from "@mui/icons-material/RemoveCircle";
import CheckCircleOutline from "@mui/icons-material/CheckCircleOutline";
import CircleIcon from "@mui/icons-material/Circle";
import NotInterestedIcon from "@mui/icons-material/NotInterested";
import CheckCircleOutlineIcon from "@mui/icons-material/CheckCircleOutline";
import InsertCommentOutlinedIcon from "@mui/icons-material/InsertCommentOutlined";
import AddCircleOutlineIcon from "@mui/icons-material/AddCircleOutline";
import ChromeReaderModeIcon from "@mui/icons-material/ChromeReaderMode";
import DynamicFeedSharpIcon from "@mui/icons-material/DynamicFeedSharp";
import AddBoxIcon from "@mui/icons-material/AddBox";
import SaveAltIcon from "@mui/icons-material/SaveAlt";
import DeleteOutlineIcon from "@mui/icons-material/DeleteOutline";
import ControlPointDuplicateIcon from "@mui/icons-material/ControlPointDuplicate";
import RemoveCircleOutlineIcon from "@mui/icons-material/RemoveCircleOutline";
import TrackChangesIcon from "@mui/icons-material/TrackChanges";
import ClearAllIcon from "@mui/icons-material/ClearAll";
import SaveOutlinedIcon from "@mui/icons-material/SaveOutlined";
import SyncTwoToneIcon from "@mui/icons-material/SyncTwoTone";
import CloudDoneIcon from "@mui/icons-material/CloudDone";
import TimelapseIcon from "@mui/icons-material/Timelapse";
import StarBorder from "@mui/icons-material/StarBorderRounded";
import StarIcon from "@mui/icons-material/StarRounded";
import VideoSettingsIcon from "@mui/icons-material/VideoSettings";
import LightbulbOutlinedIcon from "@mui/icons-material/LightbulbOutlined";
import WebAssetOutlinedIcon from "@mui/icons-material/WebAssetOutlined";
import ChatOutlinedIcon from "@mui/icons-material/ChatOutlined";
import QuestionAnswerOutlinedIcon from "@mui/icons-material/QuestionAnswerOutlined";
import OndemandVideoOutlinedIcon from "@mui/icons-material/OndemandVideoOutlined";
import TextSnippetOutlinedIcon from "@mui/icons-material/TextSnippetOutlined";
import ArrowForwardIosIcon from "@mui/icons-material/ArrowForwardIos";
import ErrorOutlineIcon from "@mui/icons-material/ErrorOutline";
import TimerOutlinedIcon from "@mui/icons-material/TimerOutlined";
import MenuOpenIcon from "@mui/icons-material/MenuOpen";
// import ExpandMore from "@mui/icons-material/ExpandMore";
// import ExpandLess from "@mui/icons-material/ExpandLess";
import ExpandLess from "@mui/icons-material/KeyboardArrowUp";
import ExpandMore from "@mui/icons-material/KeyboardArrowDown";
import PendingActionsIcon from "@mui/icons-material/PendingActions";
import WorkOutlineIcon from "@mui/icons-material/WorkOutline";
import ShowChartIcon from "@mui/icons-material/ShowChart";
import RadioButtonCheckedIcon from "@mui/icons-material/RadioButtonChecked";
import RadioButtonUncheckedIcon from "@mui/icons-material/RadioButtonUnchecked";
import EmailIcon from "@mui/icons-material/Email";
import CreateNewFolderIcon from "@mui/icons-material/CreateNewFolder";
import PlaylistPlayIcon from "@mui/icons-material/PlaylistPlay";
import DriveFileMoveOutlinedIcon from "@mui/icons-material/DriveFileMoveOutlined";
import UndoIcon from "@mui/icons-material/Undo";
import PublishedWithChangesIcon from "@mui/icons-material/PublishedWithChanges";
import SourceIcon from "@mui/icons-material/Source";
import CircularProgress from "@mui/material/CircularProgress";
import DoneIcon from "@mui/icons-material/Done";
import LogoutIcon from "@mui/icons-material/Logout";
import SaveIcon from "@mui/icons-material/Save";
import RefreshIcon from "@mui/icons-material/Refresh";
import LoopIcon from "@mui/icons-material/Loop";
import FactCheckOutlinedIcon from "@mui/icons-material/FactCheckOutlined";
import VerticalSplitOutlinedIcon from "@mui/icons-material/VerticalSplitOutlined";
import RateReviewOutlinedIcon from "@mui/icons-material/RateReviewOutlined";
import VerifiedUserOutlinedIcon from "@mui/icons-material/VerifiedUserOutlined";
import DeleteSweepOutlinedIcon from "@mui/icons-material/DeleteSweepOutlined";
import AppsIcon from "@mui/icons-material/Apps";
import AutoAwesomeIcon from "@mui/icons-material/AutoAwesome";
import TuneRoundedIcon from "@mui/icons-material/TuneRounded";
import FilterListRounded from "@mui/icons-material/FilterListRounded";
import DonutLargeIcon from "@mui/icons-material/DonutLarge";
import MaximizeIcon from "@mui/icons-material/Maximize";
import MinimizeIcon from "@mui/icons-material/Minimize";
import GridOnIcon from "@mui/icons-material/GridOn";
import GridViewIcon from "@mui/icons-material/GridView";
import BookIcon from "@mui/icons-material/Book";
import AttachMoneyIcon from "@mui/icons-material/AttachMoney";
import CallMergeIcon from "@mui/icons-material/CallMerge";
import RecentActorsIcon from "@mui/icons-material/RecentActors";
import TipsAndUpdatesOutlinedIcon from "@mui/icons-material/TipsAndUpdatesOutlined";
import OfflineBoltOutlinedIcon from "@mui/icons-material/OfflineBoltOutlined";
import OutlinedFlagIcon from "@mui/icons-material/OutlinedFlag";
import FormatAlignLeftIcon from "@mui/icons-material/FormatAlignLeft";
import FlashOnIcon from "@mui/icons-material/FlashOn";
import ArticleIcon from "@mui/icons-material/Article";
import VisibilityIcon from "@mui/icons-material/Visibility";
import VisibilityOffIcon from "@mui/icons-material/VisibilityOff";
import WebIcon from "@mui/icons-material/Web";
import VideocamOutlinedIcon from "@mui/icons-material/VideocamOutlined";
import BookOutlinedIcon from "@mui/icons-material/BookOutlined";
import SyncIcon from "@mui/icons-material/Sync";
import SearchOffIcon from "@mui/icons-material/SearchOff";
import TaskAltIcon from "@mui/icons-material/TaskAlt";
import DriveFileMoveIcon from "@mui/icons-material/DriveFileMove";
import ImageIcon from "@mui/icons-material/Image";
import WorkOffOutlinedIcon from "@mui/icons-material/WorkOffOutlined";
import PendingOutlinedIcon from "@mui/icons-material/PendingOutlined";

import SFSvgIcon from "./svgIcon";
import { PROPS, DEFAULTPROPS } from "./props";

import {
  EnlargeIcon,
  TrendUpIcon,
  TrendDownIcon,
  UpIcon,
  DownIcon,
  EmergingIcon,
  DetailsIcon,
  DetailBarsIcon,
  BetaIcon,
  PCCheckIcon,
  LoadingIcon,
} from "../../assets/icons";

//import SVGs as components
import { ReactComponent as EnableIcon } from "../../assets/icons/enable.svg";
import { ReactComponent as DisableIcon } from "../../assets/icons/disable.svg";
import { ReactComponent as BusinessUnitsIcon } from "../../assets/icons/business-units.svg";
import { ReactComponent as EmptyListPlaceholderIcon } from "../../assets/icons/empty-list-placeholder.svg";
import { ReactComponent as AssessmentCardIcon } from "../../assets/icons/assessment-card.svg";
import { ReactComponent as DefaultBannerIcon } from "../../assets/icons/default-banner.svg";
import { ReactComponent as AssessmentsIntoIcon } from "../../assets/icons/assessments-intro.svg";
import { ReactComponent as EntryIcon } from "../../assets/icons/entry.svg";
import { ReactComponent as IntermediateIcon } from "../../assets/icons/intermediate.svg";
import { ReactComponent as AdvancedIcon } from "../../assets/icons/advanced.svg";
import { ReactComponent as MasteryIcon } from "../../assets/icons/mastery.svg";
import { ReactComponent as EmployeesBannerIcon } from "../../assets/icons/employees-banner.svg";
import { ReactComponent as SkillsBannerIcon } from "../../assets/icons/skills-banner.svg";
import { ReactComponent as BusinessCapabilityDefaultIcon } from "../../assets/icons/default-bc-icon.svg";
import { ReactComponent as SkillsFrameworkCardIcon } from "../../assets/icons/skills-framework-card.svg";
import { ReactComponent as ContentStudioCardIcon } from "../../assets/icons/content-studio-card.svg";
import { ReactComponent as CareerTrackIcon } from "../../assets/icons/career-track.svg";
import { ReactComponent as DragNDropFileIcon } from "../../assets/icons/drag-drop-file.svg";
import { ReactComponent as XLSXIcon } from "../../assets/icons/xlsx-icon.svg";
import { ReactComponent as DoubleArrowIcon } from "../../assets/icons/double-arrow.svg";
import { ReactComponent as DocumentIcon } from "../../assets/icons/document.svg";
import { ReactComponent as SkillsExplorerIcon } from "../../assets/icons/skills-explorer-icon.svg";
import { ReactComponent as MaintenanceIcon } from "../../assets/icons/maintenance.svg";
import { ReactComponent as EYSFLogoGreyIcon } from "../../assets/icons/eysf-logo-grey.svg";
import { ReactComponent as UndrawNotifyIcon } from "../../assets/icons/undraw-notify.svg";
import { ReactComponent as DragHandleIcon } from "../../assets/icons/drag-handle.svg";
import { ReactComponent as BenchmarkJobIcon } from "../../assets/icons/benchmark-job.svg";
import { ReactComponent as SearchBarIcon } from "../../assets/icons/search-bar.svg";
import { ReactComponent as JobFinderSearchIcon } from "../../assets/icons/job-finder-search.svg";
import { ReactComponent as JfaJobs } from "../../assets/icons/jfa-jobs.svg";
import { ReactComponent as JfaBusinessCapabilities } from "../../assets/icons/jfa-business-capabilities.svg";
import { ReactComponent as JfaJobFinder } from "../../assets/icons/jfa-job-finder.svg";
import { ReactComponent as JfaJobExplorer } from "../../assets/icons/jfa-job-explorer.svg";
import { ReactComponent as FavoritesIcon } from "../../assets/icons/favorites.svg";
import { ReactComponent as InformationIcon } from "../../assets/icons/information-icon.svg";
import { ReactComponent as CopilotIcon } from "../../assets/icons/copilot.svg";
import { ReactComponent as SendIcon } from "../../assets/icons/send.svg";
import { ReactComponent as OnetLogo } from "../../assets/icons/ONET-logo.svg";
import { ReactComponent as MotifFilterIcon } from "../../assets/icons/filter.svg";


import { ReactComponent as SkillsFrameworkAddJobsFromFavourites } from "../../assets/icons/skills-framework-add-from-favorites-list.svg";
import { ReactComponent as SkillsFrameworkAddJobsFromBenchmark } from "../../assets/icons/skills-framework-add-from-benchmark-jobs.svg";
import { ReactComponent as SkillsFrameworkAddJobsFromClient } from "../../assets/icons/skills-framework-add-from-client-jobs.svg";
import { ReactComponent as SkillsFrameworkImportJobs } from "../../assets/icons/skills-framework-import-jobs.svg";
import { ReactComponent as SkillsFrameworkInformationImport } from "../../assets/icons/skillsframework.information-icon.svg";
import { ReactComponent as ContentThumbnailPlaceholder } from "../../assets/icons/content-thumbnail-placeholder.svg";

// SF Card Icons
import { ReactComponent as SoftwareEngineerCardIcon } from "../../assets/icons/sfCardIcons/stand-out.svg";
import { ReactComponent as InvestingCardIcon } from "../../assets/icons/sfCardIcons/investing.svg";
import { ReactComponent as EngineeringTeamCardIcon } from "../../assets/icons/sfCardIcons/engineering-team.svg";
import { ReactComponent as AddInformationCardIcon } from "../../assets/icons/sfCardIcons/add-information.svg";
import { ReactComponent as TeamCollaborationCardIcon } from "../../assets/icons/sfCardIcons/team_collaboration.svg";
import { ReactComponent as GroupSelfieCardIcon } from "../../assets/icons/sfCardIcons/group_selfie.svg";
import { ReactComponent as ConnectingTeamsCardIcon } from "../../assets/icons/sfCardIcons/connecting-teams.svg";
import { ReactComponent as CreativeTeamCardIcon } from "../../assets/icons/sfCardIcons/creative-team.svg";
import { ReactComponent as SpecsCardIcon } from "../../assets/icons/sfCardIcons/specs.svg";
import { ReactComponent as DefaultCardIcon } from "../../assets/icons/sfCardIcons/default.svg";
import { ReactComponent as StandOutCardIcon } from "../../assets/icons/sfCardIcons/stand-out.svg";
import { ReactComponent as GoingUpCardIcon } from "../../assets/icons/sfCardIcons/going-up.svg";
import { ReactComponent as ExportFilesCardIcon } from "../../assets/icons/sfCardIcons/export_files.svg";
import { ReactComponent as SkillpathTemplateCardIcon } from "../../assets/icons/sfCardIcons/skillpath-template.svg";
import { ReactComponent as CatalogIcon } from "../../assets/icons/sfCardIcons/catalog_logo.svg";
import { ReactComponent as CoursesIcon } from "../../assets/icons/sfCardIcons/courses_logo.svg";
import { ReactComponent as PlayListIcon } from "../../assets/icons/sfCardIcons/playList_logo.svg";

import { ReactComponent as EnergizeCreateNewContent } from "../../assets/icons/create-new-content.svg";

import { ReactComponent as EnergizeLandingIcon } from "../../assets/icons/energize-landing-icon.svg";
import { ReactComponent as EnergizeUploadIcon } from "../../assets/icons/energize-import-icon.svg";
import { ReactComponent as RevertIcon } from "../../assets/icons/revert.svg";

import { ReactComponent as MarkInactiveIcon } from "../../assets/icons/mark-inactive.svg";
import { ReactComponent as TasksInProgressIcon } from "../../assets/icons/tasks-in-progress.svg";
import { ReactComponent as TasksInProgressCircleIcon } from "../../assets/icons/tasks-in-progress-circle.svg";
import { ReactComponent as CommentsIcon } from "../../assets/icons/comments.svg";
import { ReactComponent as CommentsCircleIcon } from "../../assets/icons/comments-circle.svg";

//#region 3rd level navigation card SVGs
import { ReactComponent as AllJobsNavIcon } from "../../assets/icons/navCardIcons/nav-all-jobs.svg";
import { ReactComponent as ByBusinessCapabilityNavIcon } from "../../assets/icons/navCardIcons/nav-by-business-capability.svg";
import { ReactComponent as FavoriteJobsNavIcon } from "../../assets/icons/navCardIcons/nav-favorite-jobs.svg";
import { ReactComponent as VisualJobsExplorerNavIcon } from "../../assets/icons/navCardIcons/nav-visual-jobs-explorer.svg";
import { ReactComponent as ClientJobMappingsNavIcon } from "../../assets/icons/navCardIcons/nav-client-job-mappings.svg";
import { ReactComponent as MarketJobFinderNavIcon } from "../../assets/icons/navCardIcons/nav-market-job-finder.svg";
import { ReactComponent as CompletionStatsNavIcon } from "../../assets/icons/navCardIcons/nav-completion-stats.svg";
import { ReactComponent as GapAnalysisNavIcon } from "../../assets/icons/navCardIcons/nav-gap-analysis.svg";
import { ReactComponent as SkillInsightsNavIcon } from "../../assets/icons/navCardIcons/nav-skill-insights.svg";
//#endregion

//#region Copilot svg icons
import { ReactComponent as CopilotAddIcon } from "../../assets/icons/copilot-add.svg";
import { ReactComponent as CopilotRemoveIcon } from "../../assets/icons/copilot-remove.svg";
import { ReactComponent as CopilotSuggestIcon } from "../../assets/icons/copilot-suggest.svg";
import { ReactComponent as CopilotEditIcon } from "../../assets/icons/copilot-edit.svg";
import { ReactComponent as CopilotLoadIcon } from "../../assets/icons/copilot-loading.svg";
//#endregion

//#region SVGs as components
export const SFEnableIcon = (props) => {
  return <SFSvgIcon inheritViewBox component={EnableIcon} {...props} />;
};

export const SFDisableIcon = (props) => {
  return <SFSvgIcon inheritViewBox component={DisableIcon} {...props} />;
};

export const SFJobFinderSearchIcon = (props) => {
  return (
    <SFSvgIcon inheritViewBox component={JobFinderSearchIcon} {...props} />
  );
};

export const SFJfaJobsIcon = (props) => {
  return <SFSvgIcon inheritViewBox component={JfaJobs} {...props} />;
};

export const SFJfaBusinessCapabilitiesIcon = (props) => {
  return (
    <SFSvgIcon inheritViewBox component={JfaBusinessCapabilities} {...props} />
  );
};

export const SFJfaJobFinderIcon = (props) => {
  return <SFSvgIcon inheritViewBox component={JfaJobFinder} {...props} />;
};

export const SFJfaJobExplorerIcon = (props) => {
  return <SFSvgIcon inheritViewBox component={JfaJobExplorer} {...props} />;
};

export const SFSearchBarIcon = (props) => {
  return <SFSvgIcon inheritViewBox component={SearchBarIcon} {...props} />;
};

export const SFBenchmarkJobIcon = (props) => {
  return <SFSvgIcon inheritViewBox component={BenchmarkJobIcon} {...props} />;
};

export const SFDragHandleIcon = (props) => {
  return <SFSvgIcon inheritViewBox component={DragHandleIcon} {...props} />;
};

export const SFMaintenanceIcon = (props) => {
  return <SFSvgIcon inheritViewBox component={MaintenanceIcon} {...props} />;
};

export const SFEYSFLogoGreyIcon = (props) => {
  return <SFSvgIcon inheritViewBox component={EYSFLogoGreyIcon} {...props} />;
};

export const SFUndrawNotifyIcon = (props) => {
  return <SFSvgIcon inheritViewBox component={UndrawNotifyIcon} {...props} />;
};

export const SFDocumentIcon = (props) => {
  return <SFSvgIcon inheritViewBox component={DocumentIcon} {...props} />;
};

export const SFDragNDropFileIcon = (props) => {
  return <SFSvgIcon inheritViewBox component={DragNDropFileIcon} {...props} />;
};

export const SFXLSXFileIcon = (props) => {
  return <SFSvgIcon inheritViewBox component={XLSXIcon} {...props} />;
};

export const SFBusinessCapabilityDefaultIcon = (props) => {
  return (
    <SFSvgIcon
      inheritViewBox
      component={BusinessCapabilityDefaultIcon}
      {...props}
    />
  );
};

export const SFJobsBannerIcon = (props) => {
  return (
    <SFSvgIcon viewBox="0 0 58 65" component={SkillsBannerIcon} {...props} />
  );
};

export const SFSkillsBannerIcon = (props) => {
  return (
    <SFSvgIcon viewBox="0 0 58 65" component={SkillsBannerIcon} {...props} />
  );
};

export const SFCopilotAddIcon = (props) => {
  return (
    <SFSvgIcon viewBox="0 0 20 20" component={CopilotAddIcon} {...props} />
  );
};

export const SFCopilotRemoveIcon = (props) => {
  return (
    <SFSvgIcon viewBox="0 0 20 20" component={CopilotRemoveIcon} {...props} />
  );
};

export const SFCopilotSuggestIcon = (props) => {
  return (
    <SFSvgIcon viewBox="0 0 20 20" component={CopilotSuggestIcon} {...props} />
  );
};

export const SFCatalogIcon = (props) => {
  return (
    <SFSvgIcon
      inheritViewBox
      component={CatalogIcon}
      {...props}
    />
  );
};

export const SFCoursesIcon = (props) => {
  return (
    <SFSvgIcon
      inheritViewBox
      component={CoursesIcon}
      {...props}
    />
  );
};

export const SFPlayListIcon = (props) => {
  return (
    <SFSvgIcon
      inheritViewBox
      component={PlayListIcon}
      {...props}
    />
  );
};



export const SFCopilotEditIcon = (props) => {
  return (
    <SFSvgIcon viewBox="0 0 20 20" component={CopilotEditIcon} {...props} />
  );
};

export const SFCopilotLoadIcon = (props) => {
  return (
    <SFSvgIcon viewBox="0 0 40 40" component={CopilotLoadIcon} {...props} />
  );
};

export const SFSkillsExplorerIcon = (props) => {
  return (
    <SFSvgIcon
      viewBox="0 0 578.0013 621.92557"
      component={SkillsExplorerIcon}
      {...props}
    />
  );
};

export const SFAssessmentsIntroIcon = (props) => {
  return (
    <SFSvgIcon
      viewBox="0 0 410 251"
      component={AssessmentsIntoIcon}
      {...props}
    />
  );
};

export const SFEntryIcon = (props) => {
  return <SFSvgIcon viewBox="0 0 73 41" component={EntryIcon} {...props} />;
};

export const SFIntermediateIcon = (props) => {
  return (
    <SFSvgIcon viewBox="0 0 73 41" component={IntermediateIcon} {...props} />
  );
};

export const SFAdvancedIcon = (props) => {
  return <SFSvgIcon viewBox="0 0 73 41" component={AdvancedIcon} {...props} />;
};

export const SFMasteryIcon = (props) => {
  return <SFSvgIcon viewBox="0 0 73 41" component={MasteryIcon} {...props} />;
};

export const SFEmployeesBannerIcon = (props) => {
  return (
    <SFSvgIcon viewBox="0 0 84 78" component={EmployeesBannerIcon} {...props} />
  );
};

export const SFBusinessUnitsIcon = (props) => {
  return (
    <SFSvgIcon viewBox="0 0 74 57" component={BusinessUnitsIcon} {...props} />
  );
};

export const SFCareerTrackIcon = (props) => {
  return (
    <SFSvgIcon viewBox="0 0 14 13" component={CareerTrackIcon} {...props} />
  );
};

export const SFAssessmentCardIcon = (props) => {
  return (
    <SFSvgIcon
      viewBox="0 0 143 121"
      component={AssessmentCardIcon}
      {...props}
    />
  );
};

export const SFAssessmentBannerIcon = (props) => {
  return (
    <SFSvgIcon viewBox="0 0 79 65" component={DefaultBannerIcon} {...props} />
  );
};

export const SFEmptyListPlaceholderIcon = (props) => {
  return (
    <SFSvgIcon
      viewBox="0 0 200 224"
      component={EmptyListPlaceholderIcon}
      {...props}
    />
  );
};

export const SFSkillsFrameworkIcon = (props) => {
  return (
    <SFSvgIcon viewBox="0 0 79 65" component={DefaultBannerIcon} {...props} />
  );
};

export const SFFavoriteJobsIcon = (props) => {
  return <SFSvgIcon viewBox="0 0 50 50" component={FavoritesIcon} {...props} />;
};

export const SFSkillsFrameworkCardIcon = (props) => {
  return (
    <SFSvgIcon
      viewBox="0 0 196 140"
      component={SkillsFrameworkCardIcon}
      {...props}
    />
  );
};

export const SFContentStudioCardIcon = (props) => (
  <SFSvgIcon
    viewBox="-10 -10 120 131"
    component={ContentStudioCardIcon}
    {...props}
  />
);

export const SFDoubleArrowIcon = (props) => {
  return (
    <SFSvgIcon viewBox="0 0 18 18" component={DoubleArrowIcon} {...props} />
  );
};

export const SFSkillsFrameworkAddJobsFromFavouritesIcon = (props) => {
  return (
    <SFSvgIcon
      inheritViewBox
      component={SkillsFrameworkAddJobsFromFavourites}
      {...props}
    />
  );
};
export const SFSkillsFrameworkAddJobsFromBenchmarkIcon = (props) => {
  return (
    <SFSvgIcon
      inheritViewBox
      component={SkillsFrameworkAddJobsFromBenchmark}
      {...props}
    />
  );
};
export const SFSkillsFrameworkAddJobsFromClientIcon = (props) => {
  return (
    <SFSvgIcon
      inheritViewBox
      component={SkillsFrameworkAddJobsFromClient}
      {...props}
    />
  );
};

export const SFSkillsFrameworkImportJobsIcon = (props) => {
  return (
    <SFSvgIcon
      inheritViewBox
      component={SkillsFrameworkImportJobs}
      {...props}
    />
  );
};

export const SFSkillsFrameworkInformationImportIcon = (props) => {
  return (
    <SFSvgIcon
      inheritViewBox
      component={SkillsFrameworkInformationImport}
      {...props}
    />
  );
};

export const SFContentThumbnailPlaceholderIcon = (props) => {
  return (
    <SFSvgIcon
      inheritViewBox
      component={ContentThumbnailPlaceholder}
      {...props}
    />
  );
};

export const SFInformationIcon = (props) => {
  return <SFSvgIcon inheritViewBox component={InformationIcon} {...props} />;
};

export const SFRevertIcon = (props) => {
  return <SFSvgIcon inheritViewBox component={RevertIcon} {...props} />;
};

export const SFMarkInactiveIcon = (props) => {
  return <SFSvgIcon inheritViewBox component={MarkInactiveIcon} {...props} />;
};

SFMarkInactiveIcon.propTypes = PROPS;
SFMarkInactiveIcon.defaultProps = DEFAULTPROPS;

export const SFTasksInProgressIcon = ({ circle, ...restProps }) => {
  return (
    <SFSvgIcon
      inheritViewBox
      component={circle ? TasksInProgressCircleIcon : TasksInProgressIcon}
      {...restProps}
    />
  );
};

SFTasksInProgressIcon.propTypes = { ...PROPS, circle: PropTypes.bool };
SFTasksInProgressIcon.defaultProps = { ...DEFAULTPROPS, circle: false };

export const SFCommentsIcon = ({ circle, ...restProps }) => {
  return (
    <SFSvgIcon
      inheritViewBox
      component={circle ? CommentsCircleIcon : CommentsIcon}
      {...restProps}
    />
  );
};

SFCommentsIcon.propTypes = { ...PROPS, circle: PropTypes.bool };
SFCommentsIcon.defaultProps = { ...DEFAULTPROPS, circle: false };

export const SFAllJobsNavIcon = (props) => {
  return <SFSvgIcon inheritViewBox component={AllJobsNavIcon} {...props} />;
};

export const SFByBusinessCapabilityNavIcon = (props) => {
  return (
    <SFSvgIcon
      inheritViewBox
      component={ByBusinessCapabilityNavIcon}
      {...props}
    />
  );
};

export const SFFavoriteJobsNavIcon = (props) => {
  return (
    <SFSvgIcon inheritViewBox component={FavoriteJobsNavIcon} {...props} />
  );
};

export const SFVisualJobsExplorerNavIcon = (props) => {
  return (
    <SFSvgIcon
      inheritViewBox
      component={VisualJobsExplorerNavIcon}
      {...props}
    />
  );
};

export const SFClientJobMappingsNavIcon = (props) => {
  return (
    <SFSvgIcon inheritViewBox component={ClientJobMappingsNavIcon} {...props} />
  );
};

export const SFMarketJobFinderNavIcon = (props) => {
  return (
    <SFSvgIcon inheritViewBox component={MarketJobFinderNavIcon} {...props} />
  );
};

export const SFCompletionStatsNavIcon = (props) => {
  return (
    <SFSvgIcon inheritViewBox component={CompletionStatsNavIcon} {...props} />
  );
};

export const SFGapAnalysisNavIcon = (props) => {
  return <SFSvgIcon inheritViewBox component={GapAnalysisNavIcon} {...props} />;
};

export const SFSkillInsightsNavIcon = (props) => {
  return (
    <SFSvgIcon inheritViewBox component={SkillInsightsNavIcon} {...props} />
  );
};

export const SFSoftwareEngineerCardIcon = (props) => {
  return (
    <SFSvgIcon
      viewBox="0 0 207 140"
      component={SoftwareEngineerCardIcon}
      {...props}
    />
  );
};

export const SFInvestingCardIcon = (props) => {
  return (
    <SFSvgIcon viewBox="0 0 191 140" component={InvestingCardIcon} {...props} />
  );
};

export const SFEngineeringTeamCardIcon = (props) => {
  return (
    <SFSvgIcon
      viewBox="0 0 200 103"
      component={EngineeringTeamCardIcon}
      {...props}
    />
  );
};

export const SFAddInformationCardIcon = (props) => {
  return (
    <SFSvgIcon
      viewBox="0 0 199 140"
      component={AddInformationCardIcon}
      {...props}
    />
  );
};

export const SFTeamCollaborationCardIcon = (props) => {
  return (
    <SFSvgIcon
      viewBox="0 0 200 113"
      component={TeamCollaborationCardIcon}
      {...props}
    />
  );
};

export const SFConnectingTeamsCardIcon = (props) => {
  return (
    <SFSvgIcon
      viewBox="0 0 162 140"
      component={ConnectingTeamsCardIcon}
      {...props}
    />
  );
};

export const SFGroupSelfieCardIcon = (props) => {
  return (
    <SFSvgIcon
      viewBox="0 0 191 140"
      component={GroupSelfieCardIcon}
      {...props}
    />
  );
};

export const SFSkillpathTemplateCardIcon = (props) => {
  return (
    <SFSvgIcon
      viewBox="0 0 100 164"
      component={SkillpathTemplateCardIcon}
      {...props}
    />
  );
};

export const SFCreativeTeamCardIcon = (props) => {
  return (
    <SFSvgIcon
      viewBox="0 0 195 140"
      component={CreativeTeamCardIcon}
      {...props}
    />
  );
};

export const SFSpecsCardIcon = (props) => {
  return (
    <SFSvgIcon viewBox="0 0 200 107" component={SpecsCardIcon} {...props} />
  );
};

export const SFDefaultCardIcon = (props) => {
  return (
    <SFSvgIcon viewBox="0 0 152 141" component={DefaultCardIcon} {...props} />
  );
};

export const SFStandOutCardIcon = (props) => {
  return (
    <SFSvgIcon viewBox="0 0 196 140" component={StandOutCardIcon} {...props} />
  );
};

export const SFGoingUpCardIcon = (props) => {
  return (
    <SFSvgIcon viewBox="0 0 156 140" component={GoingUpCardIcon} {...props} />
  );
};

export const SFExportFilesCardIcon = (props) => {
  return (
    <SFSvgIcon
      viewBox="0 0 120 140"
      component={ExportFilesCardIcon}
      {...props}
    />
  );
};

export const SFExploreCopilotIcon = (props) => {
  return <SFSvgIcon inheritViewBox component={CopilotIcon} {...props} />;
};

export const SFSendIcon = (props) => {
  return <SFSvgIcon inheritViewBox component={SendIcon} {...props} />;
};

export const SFOnetLogo = (props) => {
  return <SFSvgIcon inheritViewBox component={OnetLogo} {...props} />;
};

export const SFFilterIcon = (props) => {
  return <SFSvgIcon inheritViewBox component={MotifFilterIcon} {...props} />;
};

//#endregion

export const SFEmergingIcon = (props) => {
  return <SFSvgIcon {...props}>{EmergingIcon}</SFSvgIcon>;
};

export const SFEnlargeIcon = (props) => {
  return <SFSvgIcon {...props}>{EnlargeIcon}</SFSvgIcon>;
};

export const SFViewDetailsIcon = (props) => {
  return <SFSvgIcon {...props}>{DetailsIcon}</SFSvgIcon>;
};

export const SFViewDetailsBarIcon = (props) => {
  return <SFSvgIcon {...props}>{DetailBarsIcon}</SFSvgIcon>;
};

export const SFBetaIcon = (props) => (
  <SFSvgIcon {...props}>{BetaIcon}</SFSvgIcon>
);

export const SFLoadingIcon = (props) => (
  <SFSvgIcon {...props}>{LoadingIcon}</SFSvgIcon>
);

export const SFPCCheckIcon = (props) => (
  <SFSvgIcon {...props}>{PCCheckIcon}</SFSvgIcon>
);

export const SFTrendUpIcon = (props) => {
  return <SFSvgIcon {...props}>{TrendUpIcon}</SFSvgIcon>;
};

export const SFTrendDownIcon = (props) => {
  return <SFSvgIcon {...props}>{TrendDownIcon}</SFSvgIcon>;
};

export const SFUpIcon = (props) => {
  return <SFSvgIcon {...props}>{UpIcon}</SFSvgIcon>;
};

export const SFDownIcon = (props) => {
  return <SFSvgIcon {...props}>{DownIcon}</SFSvgIcon>;
};

export const SFEnergizeCreateNewContent = (props) => {
  return (
    <SFSvgIcon inheritViewBox component={EnergizeCreateNewContent} {...props} />
  );
};

export const SFEnergizeLandingIcon = (props) => {
  return (
    <SFSvgIcon inheritViewBox component={EnergizeLandingIcon} {...props} />
  );
};

export const SFEnergizeUploadIcon = (props) => {
  return <SFSvgIcon inheritViewBox component={EnergizeUploadIcon} {...props} />;
};
//#endregion

//#region MUI icons
export const SFVisibilityIcon = (props) => {
  return (
    <VisibilityIcon color={props.color} fontSize={props.size} {...props} />
  );
};

export const SFVisibilityOffIcon = (props) => {
  return (
    <VisibilityOffIcon color={props.color} fontSize={props.size} {...props} />
  );
};

export const SFArticleIcon = (props) => {
  return <ArticleIcon color={props.color} fontSize={props.size} {...props} />;
};

export const SFFlashIcon = (props) => {
  return <FlashOnIcon color={props.color} fontSize={props.size} {...props} />;
};

export const SFOutlinedFlagIcon = (props) => {
  return (
    <OutlinedFlagIcon color={props.color} fontSize={props.size} {...props} />
  );
};

export const SFFormatAlignLeftIcon = (props) => {
  return (
    <FormatAlignLeftIcon color={props.color} fontSize={props.size} {...props} />
  );
};

export const SFWebIcon = (props) => {
  return <WebIcon color={props.color} fontSize={props.size} {...props} />;
};

export const SFVideocamOutlinedIcon = (props) => {
  return (
    <VideocamOutlinedIcon
      color={props.color}
      fontSize={props.size}
      {...props}
    />
  );
};

export const SFBookOutlinedIcon = (props) => {
  return (
    <BookOutlinedIcon color={props.color} fontSize={props.size} {...props} />
  );
};

export const SFCheckCircleOutline = (props) => (
  <CheckCircleOutline {...props} />
);

export const SFPlaylistIcon = (props) => {
  return (
    <PlaylistPlayIcon color={props.color} fontSize={props.size} {...props} />
  );
};

export const SFErrorOutlineIcon = (props) => {
  return (
    <ErrorOutlineIcon color={props.color} fontSize={props.size} {...props} />
  );
};

export const SFPendingActionsIcon = (props) => {
  return (
    <PendingActionsIcon color={props.color} fontSize={props.size} {...props} />
  );
};

export const SFArrowIcon = (props) => {
  return (
    <ArrowForwardIosIcon color={props.color} fontSize={props.size} {...props} />
  );
};

export const SFStarIcon = (props) => {
  return <StarIcon color={props.color} fontSize={props.size} {...props} />;
};

export const SFStarBorderIcon = (props) => {
  return <StarBorder color={props.color} fontSize={props.size} {...props} />;
};

export const SFScoreIcon = (props) => {
  return (
    <TrackChangesIcon color={props.color} fontSize={props.size} {...props} />
  );
};

export const SFSaveOutlinedIcon = (props) => {
  return (
    <SaveOutlinedIcon color={props.color} fontSize={props.size} {...props} />
  );
};

export const SFClearAllIcon = (props) => {
  return <ClearAllIcon color={props.color} fontSize={props.size} {...props} />;
};

export const SFDublicateIcon = (props) => {
  return (
    <ControlPointDuplicateIcon
      color={props.color}
      fontSize={props.size}
      {...props}
    />
  );
};

export const SFRemoveOutlineCircleIcon = (props) => {
  return (
    <RemoveCircleOutlineIcon
      color={props.color}
      fontSize={props.size}
      {...props}
    />
  );
};

export const SFCommentIcon = (props) => {
  return (
    <InsertCommentOutlinedIcon
      color={props.color}
      fontSize={props.size}
      {...props}
    />
  );
};

export const SFNotInterestedIcon = (props) => {
  return (
    <NotInterestedIcon color={props.color} fontSize={props.size} {...props} />
  );
};

export const SFCheckCircleOutlineIcon = (props) => {
  return (
    <CheckCircleOutlineIcon
      color={props.color}
      fontSize={props.size}
      {...props}
    />
  );
};

export const SFCircleIcon = (props) => {
  return <CircleIcon color={props.color} fontSize={props.size} {...props} />;
};

export const SFRowGroupIcon = (props) => {
  return (
    <DynamicFeedSharpIcon
      color={props.color}
      fontSize={props.size}
      {...props}
    />
  );
};

export const SFAddBoxIcon = (props) => {
  return <AddBoxIcon color={props.color} fontSize={props.size} {...props} />;
};

export const SFAddCircleIcon = (props) => {
  return (
    <AddCircleOutlineIcon
      color={props.color}
      fontSize={props.size}
      {...props}
    />
  );
};

export const SFSwapHorizIcon = (props) => {
  return <SwapHorizIcon color={props.color} fontSize={props.size} {...props} />;
};

export const SFCancelTwoToneIcon = (props) => {
  return (
    <CancelTwoToneIcon color={props.color} fontSize={props.size} {...props} />
  );
};

export const SFArrowDropDownIcon = (props) => {
  return (
    <ArrowDropDownIcon color={props.color} fontSize={props.size} {...props} />
  );
};

export const SFClearIcon = (props) => {
  return <ClearIcon color={props.color} fontSize={props.size} {...props} />;
};
export const SFArrowDownWardIcon = (props) => {
  return (
    <ArrowDownwardIcon color={props.color} fontSize={props.size} {...props} />
  );
};
export const SFArrowUpWardIcon = (props) => {
  return (
    <ArrowUpwardIcon color={props.color} fontSize={props.size} {...props} />
  );
};

export const SFAccountTreeIcon = (props) => {
  return (
    <AccountTreeRoundedIcon
      color={props.color}
      fontSize={props.size}
      {...props}
    />
  );
};

export const SFCategoryIcon = (props) => {
  return <CategoryIcon color={props.color} fontSize={props.size} {...props} />;
};

export const SFAssessmentIcon = (props) => {
  return <AssessmentOutlinedIcon fontSize="sizebarNavigation" {...props} />;
};

export const SFReportIcon = (props) => {
  return <BackupTableIcon fontSize="sizebarNavigation" {...props} />;
};

export const SFSkillsBenchmarkIcon = (props) => {
  return <PlaylistAddCheckIcon fontSize="sizebarNavigation" {...props} />;
};

export const SFDashboardIcon = (props) => {
  return <DashboardOutlinedIcon fontSize="sizebarNavigation" {...props} />;
};

export const SFBenchmarkIcon = (props) => {
  return (
    <InsightsIcon
      color={props.color}
      fontSize={props.size ?? "sizebarNavigation"}
      {...props}
    />
  );
};

SFBenchmarkIcon.propTypes = PROPS;
SFBenchmarkIcon.defaultProps = DEFAULTPROPS;

export const SFLearningIntelligenceIcon = (props) => {
  return (
    <ChromeReaderModeIcon
      fontSize={props.size ?? "sizebarNavigation"}
      {...props}
    />
  );
};

export const SFPlanIcon = (props) => {
  return <ListAltTwoToneIcon fontSize="sizebarNavigation" {...props} />;
};

export const SFHelpSupportIcon = ({ size, ...restProps }) => {
  return <HelpOutlineOutlinedIcon fontSize={size} {...restProps} />;
};

SFHelpSupportIcon.propTypes = PROPS;
SFHelpSupportIcon.defaultProps = { ...DEFAULTPROPS, size: "sizebarNavigation" };

export const SFAdministrationIcon = (props) => {
  return <SettingsTwoToneIcon fontSize="sizebarNavigation" {...props} />;
};

export const SFExecutionFlowsIcon = (props) => {
  return (
    <SyncTwoToneIcon
      color={props.color}
      fontSize="sizebarNavigation"
      {...props}
    />
  );
};

SFExecutionFlowsIcon.propTypes = PROPS;
SFExecutionFlowsIcon.defaultProps = DEFAULTPROPS;

export const SFBarChartNoBorderIcon = (props) => {
  return <BarChartIcon {...props} />;
};

export const SFBarChartIcon = (props) => {
  return <InsertChartTwoToneIcon {...props} />;
};

export const SFBarChartWithLineIcon = (props) => {
  return <ListAltTwoToneIcon {...props} />;
};

export const SFFileOpenIcon = (props) => {
  return <FileOpenIcon {...props} />;
};

export const SFSectorsIcon = (props) => {
  return <PieChartIcon {...props} />;
};

export const SFEmailIcon = ({ size, ...props }) => (
  <EmailIcon fontSize={size} {...props} />
);

export const SFJobsIcon = (props) => (
  <WorkIcon color={props.color} fontSize={props.size} {...props} />
);

export const SFSkillsIcon = (props) => (
  <RecentActorsIcon color={props.color} fontSize={props.size} {...props} />
);

export const SFBuildIcon = (props) => (
  <BuildIcon color={props.color} fontSize={props.size} {...props} />
);

export const SFOrganizationsIcon = (props) => (
  <HomeWorkIcon color={props.color} fontSize={props.size} {...props} />
);

export const SFTextSnippetIcon = (props) => (
  <TextSnippetIcon color={props.color} fontSize={props.size} {...props} />
);

export const SFBubbleChartIcon = (props) => {
  return (
    <BubbleChartIcon color={props.color} fontSize={props.size} {...props} />
  );
};

SFBubbleChartIcon.propTypes = PROPS;
SFBubbleChartIcon.defaultProps = DEFAULTPROPS;

export const SFSignalCelluralIcon = (props) => {
  return <SignalCellularAltIcon color={props.color} fontSize={props.size} />;
};

SFSignalCelluralIcon.propTypes = PROPS;
SFSignalCelluralIcon.defaultProps = DEFAULTPROPS;

export const SFCopyIcon = (props) => {
  return <ContentCopyIcon color={props.color} fontSize={props.size} />;
};

SFCopyIcon.propTypes = PROPS;
SFCopyIcon.defaultProps = DEFAULTPROPS;

export const SFCheckIcon = (props) => {
  return <Check color={props.color} fontSize={props.size} />;
};

SFCheckIcon.propTypes = PROPS;
SFCheckIcon.defaultProps = DEFAULTPROPS;

export const SFCheckmarkIcon = (props) => {
  return <CheckOutlinedIcon color={props.color} fontSize={props.size} />;
};

SFCheckmarkIcon.propTypes = PROPS;
SFCheckmarkIcon.defaultProps = DEFAULTPROPS;

export const SFMenuIcon = (props) => {
  return <MenuIcon color={props.color} fontSize={props.size} />;
};

SFMenuIcon.propTypes = PROPS;
SFMenuIcon.defaultProps = DEFAULTPROPS;

export const SFEditIcon = (props) => {
  return <EditIcon color={props.color} fontSize={props.size} />;
};

SFEditIcon.propTypes = PROPS;
SFEditIcon.defaultProps = DEFAULTPROPS;

export const SFDeleteIcon = (props) => {
  return <DeleteIcon color={props.color} fontSize={props.size} />;
};

SFDeleteIcon.propTypes = PROPS;
SFDeleteIcon.defaultProps = DEFAULTPROPS;

export const SFDownloadIcon = (props) => {
  return <DownloadIcon color={props.color} fontSize={props.size} />;
};

SFDownloadIcon.propTypes = PROPS;
SFDownloadIcon.defaultProps = DEFAULTPROPS;

export const SFPlaylistAddIcon = (props) => {
  return <PlaylistAddIcon color={props.color} fontSize={props.size} />;
};

SFPlaylistAddIcon.propTypes = PROPS;
SFPlaylistAddIcon.defaultProps = DEFAULTPROPS;

export const SFTipIcon = (props) => {
  return <LightbulbOutlinedIcon color={props.color} fontSize={props.size} />;
};

SFTipIcon.propTypes = PROPS;
SFTipIcon.defaultProps = DEFAULTPROPS;

export const SFOpenInNewIcon = (props) => {
  return <OpenInNewIcon color={props.color} fontSize={props.size} />;
};

SFOpenInNewIcon.propTypes = PROPS;
SFOpenInNewIcon.defaultProps = DEFAULTPROPS;

export const SFSearchIcon = (props) => {
  return <SearchIcon color={props.color} fontSize={props.size} />;
};

SearchIcon.propTypes = PROPS;
SearchIcon.defaultProps = DEFAULTPROPS;

export const SFInfoIcon = (props) => {
  return <InfoOutlinedIcon color={props.color} fontSize={props.size} />;
};

SFInfoIcon.propTypes = PROPS;
SFInfoIcon.defaultProps = DEFAULTPROPS;

export const SFPlaceHolder = (props) => {
  return <HelpOutlineIcon color={props.color} fontSize={props.size} />;
};

SFPlaceHolder.propTypes = PROPS;
SFPlaceHolder.defaultProps = DEFAULTPROPS;

export const SFCheckboxUnchecked = (props) => {
  return <CheckBoxOutlineBlankIcon color={props.color} fontSize={props.size} />;
};

SFCheckboxUnchecked.propTypes = PROPS;
SFCheckboxUnchecked.defaultProps = DEFAULTPROPS;

export const SFCheckboxChecked = (props) => {
  return <CheckBoxIcon color={props.color} fontSize={props.size} />;
};

SFCheckboxChecked.propTypes = PROPS;
SFCheckboxChecked.defaultProps = DEFAULTPROPS;

export const SFCheckboxIdeterminateIcon = (props) => {
  return (
    <IndeterminateCheckBoxIcon color={props.color} fontSize={props.size} />
  );
};

SFCheckboxIdeterminateIcon.propTypes = PROPS;
SFCheckboxIdeterminateIcon.defaultProps = DEFAULTPROPS;

export const SFNotificationIcon = (props) => {
  return <NotificationsTwoToneIcon color={props.color} fontSize={props.size} />;
};

SFNotificationIcon.propTypes = PROPS;
SFNotificationIcon.defaultProps = DEFAULTPROPS;

export const SFTrendingFlat = (props) => {
  return <ArrowRightAltIcon color={props.color} fontSize={props.size} />;
};

SFTrendingFlat.propTypes = PROPS;
SFTrendingFlat.defaultProps = { ...DEFAULTPROPS, color: "blue400" };

export const SFTrendingDown = (props) => {
  return <TrendingDownIcon color={props.color} fontSize={props.size} />;
};

SFTrendingDown.propTypes = PROPS;
SFTrendingDown.defaultProps = { ...DEFAULTPROPS, color: "red400" };

export const SFTrendingUp = (props) => {
  return <TrendingUpIcon color={props.color} fontSize={props.size} />;
};

SFTrendingUp.propTypes = PROPS;
SFTrendingUp.defaultProps = { ...DEFAULTPROPS, color: "green400" };

export const SFCloseIcon = (props) => {
  return <CloseIcon color={props.color} fontSize={props.size} {...props} />;
};

SFCloseIcon.propTypes = PROPS;
SFCloseIcon.defaultProps = DEFAULTPROPS;

export const SFLanguageIcon = (props) => {
  return <LanguageIcon color={props.color} fontSize={props.size} />;
};

SFLanguageIcon.propTypes = PROPS;
SFLanguageIcon.defaultProps = DEFAULTPROPS;

export const SFArrowBackIcon = (props) => {
  return <ArrowBackIcon color={props.color} fontSize={props.size} />;
};

SFArrowBackIcon.propTypes = PROPS;
SFArrowBackIcon.defaultProps = DEFAULTPROPS;

export const SFArrowForwardIcon = (props) => {
  return <ArrowForwardIcon color={props.color} fontSize={props.size} />;
};

SFArrowForwardIcon.propTypes = PROPS;
SFArrowForwardIcon.defaultProps = DEFAULTPROPS;

export const SFArrowDownIcon = (props) => {
  return (
    <KeyboardArrowDownIcon
      color={props.color}
      fontSize={props.size}
      {...props}
    />
  );
};

SFArrowDownIcon.propTypes = PROPS;
SFArrowDownIcon.defaultProps = DEFAULTPROPS;

export const SFArrowUpIcon = (props) => {
  return <KeyboardArrowUpIcon color={props.color} fontSize={props.size} />;
};

SFArrowUpIcon.propTypes = PROPS;
SFArrowUpIcon.defaultProps = DEFAULTPROPS;

export const SFAddIcon = (props) => {
  return <AddIcon color={props.color} fontSize={props.size} />;
};

SFAddIcon.propTypes = PROPS;
SFAddIcon.defaultProps = DEFAULTPROPS;

export const SFMoreVerticalIcon = (props) => {
  return <MoreVertIcon color={props.color} fontSize={props.size} />;
};

SFMoreVerticalIcon.propTypes = PROPS;
SFMoreVerticalIcon.defaultProps = DEFAULTPROPS;

export const SFMoreHorizontalIcon = (props) => {
  return <MoreHorizIcon color={props.color} fontSize={props.size} />;
};

SFMoreHorizontalIcon.propTypes = PROPS;
SFMoreHorizontalIcon.defaultProps = DEFAULTPROPS;

export const SFSettingsIcon = (props) => {
  return <SettingsTwoToneIcon {...props} />;
};

SFSettingsIcon.propTypes = PROPS;
SFSettingsIcon.defaultProps = DEFAULTPROPS;

export const SFMinusIcon = (props) => {
  return <RemoveIcon scolor={props.color} fontSize={props.size} />;
};
export const SFKeyboardArrowLeftIcon = (props) => {
  return <KeyboardArrowLeftIcon color={props.color} fontSize={props.size} />;
};

SFKeyboardArrowLeftIcon.propTypes = PROPS;
SFKeyboardArrowLeftIcon.defaultProps = DEFAULTPROPS;

export const SFKeyboardArrowRightIcon = (props) => {
  return <KeyboardArrowRightIcon color={props.color} fontSize={props.size} />;
};

SFKeyboardArrowRightIcon.propTypes = PROPS;
SFKeyboardArrowRightIcon.defaultProps = DEFAULTPROPS;

export const SFSubdirectoryArrowRightIcon = (props) => {
  return (
    <SubdirectoryArrowRightIcon color={props.color} fontSize={props.size} />
  );
};

SFSubdirectoryArrowRightIcon.propTypes = PROPS;
SFSubdirectoryArrowRightIcon.defaultProps = DEFAULTPROPS;

export const SFCheckCircleIcon = (props) => {
  return <CheckCircleIcon color={props.color} fontSize={props.size} />;
};

SFCheckCircleIcon.propTypes = PROPS;
SFCheckCircleIcon.defaultProps = { ...DEFAULTPROPS, color: "green300" };

export const SFErrorIcon = (props) => {
  return <ErrorIcon color={props.color} fontSize={props.size} />;
};

SFErrorIcon.propTypes = PROPS;
SFErrorIcon.defaultProps = { ...DEFAULTPROPS, color: "red300" };

export const SFWarningIcon = (props) => {
  return props.rounded ? (
    <WarningRoundedIcon color={props.color} fontSize={props.size} />
  ) : (
    <WarningIcon color={props.color} fontSize={props.size} />
  );
};

SFWarningIcon.propTypes = PROPS;
SFWarningIcon.defaultProps = { ...DEFAULTPROPS, color: "red300" };

export const SFWarningAmberIcon = (props) => {
  return props.rounded ? (
    <WarningAmberRoundedIcon color={props.color} fontSize={props.size} />
  ) : (
    <WarningAmberIcon color={props.color} fontSize={props.size} />
  );
};

SFWarningAmberIcon.propTypes = PROPS;
SFWarningAmberIcon.defaultProps = { ...DEFAULTPROPS, color: "red300" };

export const SFInfoIconFilled = (props) => {
  return <InfoIcon color={props.color} fontSize={props.size} />;
};

SFInfoIconFilled.propTypes = PROPS;
SFInfoIconFilled.defaultProps = { ...DEFAULTPROPS, color: "grey300" };

export const SFWorkOutlineIcon = (props) => (
  <WorkOutlineIcon color={props.color} fontSize={props.size} />
);

SFWorkOutlineIcon.propTypes = PROPS;
SFWorkOutlineIcon.defaultProps = DEFAULTPROPS;

export const SFShowChartIcon = (props) => (
  <ShowChartIcon color={props.color} fontSize={props.size} />
);

SFShowChartIcon.propTypes = PROPS;
SFShowChartIcon.defaultProps = DEFAULTPROPS;

export const SFPlaylistAddCheckIcon = (props) => (
  <PlaylistAddCheckIcon color={props.color} fontSize={props.size} />
);

SFPlaylistAddCheckIcon.propTypes = PROPS;
SFPlaylistAddCheckIcon.defaultProps = DEFAULTPROPS;

export const SFNavigateNext = (props) => {
  return <NavigateNext color={props.color} fontSize={props.size} />;
};

SFInfoIconFilled.propTypes = PROPS;
SFInfoIconFilled.defaultProps = { ...DEFAULTPROPS, color: "blue500" };

export const SFDeleteForeverIcon = (props) => {
  return (
    <DeleteForeverIcon sx={{ color: props.color }} fontSize={props.size} />
  );
};

SFDeleteForeverIcon.propTypes = PROPS;
SFDeleteForeverIcon.defaultProps = { ...DEFAULTPROPS, color: "grey500" };

export const SFSettingsIconFilled = (props) => {
  return <SettingsSharpIcon color={props.color} fontSize={props.size} />;
};

SFSettingsIconFilled.propTypes = PROPS;
SFSettingsIconFilled.defaultProps = { ...DEFAULTPROPS, color: "blue500" };

export const SFNewReleasesIcon = (props) => {
  return <NewReleasesIcon color={props.color} fontSize={props.size} />;
};

SFNewReleasesIcon.propTypes = PROPS;
SFNewReleasesIcon.defaultProps = { ...DEFAULTPROPS, color: "blue500" };

export const SFArrowRightIcon = (props) => {
  return <ArrowRightIcon color={props.color} fontSize={props.size} />;
};

SFArrowRightIcon.propTypes = PROPS;
SFArrowRightIcon.defaultProps = { ...DEFAULTPROPS, color: "grey400" };

export const SFPeopleIcon = (props) => {
  return <PeopleIcon color={props.color} fontSize={props.size} />;
};

SFPeopleIcon.propTypes = PROPS;
SFPeopleIcon.defaultProps = { ...DEFAULTPROPS, color: "purple300" };

export const SFRenewIcon = (props) => {
  return <AutorenewIcon sx={{ color: props.color }} fontSize={props.size} />;
};

SFRenewIcon.propTypes = PROPS;
SFRenewIcon.defaultProps = { ...DEFAULTPROPS, color: "grey400" };

export const SFArrowMergeIcon = (props) => {
  return <MergeTypeIcon sx={{ color: props.color }} fontSize={props.size} />;
};

SFArrowMergeIcon.propTypes = PROPS;
SFArrowMergeIcon.defaultProps = { ...DEFAULTPROPS, color: "grey400" };

export const SFRemoveCircleIcon = (props) => {
  return <RemoveCircleIcon sx={{ color: props.color }} fontSize={props.size} />;
};

SFRemoveCircleIcon.propTypes = PROPS;
SFRemoveCircleIcon.defaultProps = { ...DEFAULTPROPS, color: "grey450" };

export const SFUploadIcon = (props) => {
  return <UploadIcon sx={{ color: props.color }} fontSize={props.size} />;
};

SFUploadIcon.propTypes = PROPS;
SFUploadIcon.defaultProps = { ...DEFAULTPROPS, color: "grey400" };

export const SFBusinessUnitIcon = (props) => {
  return <LocationCityIcon color={props.color} fontSize={props.size} />;
};

SFBusinessUnitIcon.propTypes = PROPS;
SFBusinessUnitIcon.defaultProps = { ...DEFAULTPROPS, color: "blue400" };

export const SFRemoveIcon = (props) => {
  return (
    <HighlightOffIcon color={props.color} fontSize={props.size} {...props} />
  );
};

SFRemoveIcon.propTypes = PROPS;
SFRemoveIcon.defaultProps = { ...DEFAULTPROPS, color: "grey500" };

export const SFFullscreenIcon = (props) => {
  return (
    <FullscreenIcon color={props.color} fontSize={props.size} {...props} />
  );
};

SFFullscreenIcon.propTypes = PROPS;
SFFullscreenIcon.defaultProps = DEFAULTPROPS;

export const SFFullscreenExitIcon = (props) => {
  return (
    <FullscreenExitIcon color={props.color} fontSize={props.size} {...props} />
  );
};

SFFullscreenExitIcon.propTypes = PROPS;
SFFullscreenExitIcon.defaultProps = DEFAULTPROPS;

export const SFUpgradeIcon = (props) => {
  return <UpgradeIcon color={props.color} fontSize={props.size} />;
};

SFUpgradeIcon.propTypes = PROPS;
SFUpgradeIcon.defaultProps = { ...DEFAULTPROPS, color: "green400" };

export const SFDowngradeIcon = (props) => {
  return (
    <UpgradeIcon
      color={props.color}
      sx={{ transform: "rotate(180deg)" }}
      fontSize={props.size}
    />
  );
};

SFDowngradeIcon.propTypes = PROPS;
SFDowngradeIcon.defaultProps = { ...DEFAULTPROPS, color: "red300" };
export const SFFiltersIcon = (props) => {
  return <FilterAltIcon color={props.color} fontSize={props.size} />;
};

SFFiltersIcon.propTypes = PROPS;
SFFiltersIcon.defaultProps = DEFAULTPROPS;

export const SFFiltersOutlinedIcon = (props) => {
  return <FilterAltOutlinedIcon color={props.color} fontSize={props.size} />;
};

SFFiltersIcon.propTypes = PROPS;
SFFiltersIcon.defaultProps = DEFAULTPROPS;

export const SFTableChartIcon = (props) => {
  return <TableChartIcon color={props.color} fontSize={props.size} />;
};

SFTableChartIcon.propTypes = PROPS;
SFTableChartIcon.defaultProps = DEFAULTPROPS;

export const SFStopIcon = (props) => {
  return <DoDisturbIcon color={props.color} fontSize={props.size} />;
};

SFTableChartIcon.propTypes = PROPS;
SFTableChartIcon.defaultProps = { ...DEFAULTPROPS, color: "grey400" };

export const SFStarRoundedIcon = (props) => {
  return <StarRoundedIcon color={props.color} fontSize={props.size} />;
};

SFStarRoundedIcon.propTypes = PROPS;
SFStarRoundedIcon.defaultProps = { ...DEFAULTPROPS };

export const SFStarBorderRoundedIcon = (props) => {
  return <StarBorderRoundedIcon color={props.color} fontSize={props.size} />;
};

SFStarBorderRoundedIcon.propTypes = PROPS;
SFStarBorderRoundedIcon.defaultProps = { ...DEFAULTPROPS, color: "grey500" };

export const SFStickyNoteIcon = (props) => {
  return <StickyNote2Outlined color={props.color} fontSize={props.size} />;
};

SFStickyNoteIcon.propTypes = PROPS;
SFStickyNoteIcon.defaultProps = DEFAULTPROPS;

export const SFHistoryIcon = (props) => {
  return <HistoryIcon color={props.color} fontSize={props.size} />;
};

SFHistoryIcon.propTypes = PROPS;
SFHistoryIcon.defaultProps = { DEFAULTPROPS };

export const SFSaveAltIcon = (props) => {
  return <SaveAltIcon color={props.color} fontSize={props.size} />;
};

SFSaveAltIcon.propTypes = PROPS;
SFSaveAltIcon.defaultProps = DEFAULTPROPS;

export const SFDeleteOutlineIcon = (props) => {
  return (
    <DeleteOutlineIcon sx={{ color: props.color }} fontSize={props.size} />
  );
};

SFDeleteOutlineIcon.propTypes = PROPS;
SFDeleteOutlineIcon.defaultProps = { ...DEFAULTPROPS, color: "grey500" };
export const SFCloudDoneIcon = (props) => {
  return <CloudDoneIcon color={props.color} fontSize={props.size} />;
};

SFCloudDoneIcon.propTypes = PROPS;
SFCloudDoneIcon.defaultProps = { DEFAULTPROPS, color: "green400" };

export const SFTimelapseIcon = (props) => {
  return <TimelapseIcon color={props.color} fontSize={props.size} />;
};

SFTimelapseIcon.propTypes = PROPS;
SFTimelapseIcon.defaultProps = { DEFAULTPROPS, color: "orange300" };
//#endregion

export const SFEnergizeIcon = (props) => (
  <VideoSettingsIcon color={props.color} fontSize={props.size} />
);

SFEnergizeIcon.propTypes = PROPS;
SFEnergizeIcon.defaultProps = { DEFAULTPROPS };

export const SFEnergizeSplashIcon = (props) => (
  <WebAssetOutlinedIcon color={props.color} fontSize={props.size} />
);

SFEnergizeSplashIcon.propTypes = PROPS;
SFEnergizeSplashIcon.defaultProps = { DEFAULTPROPS };

export const SFEnergizeChatIcon = (props) => (
  <ChatOutlinedIcon color={props.color} fontSize={props.size} />
);

SFEnergizeChatIcon.propTypes = PROPS;
SFEnergizeChatIcon.defaultProps = { DEFAULTPROPS };

export const SFEnergizeSelfEvaluationIcon = (props) => (
  <QuestionAnswerOutlinedIcon color={props.color} fontSize={props.size} />
);

SFEnergizeSelfEvaluationIcon.propTypes = PROPS;
SFEnergizeSelfEvaluationIcon.defaultProps = { DEFAULTPROPS };

export const SFEnergizeVideoIcon = (props) => (
  <OndemandVideoOutlinedIcon color={props.color} fontSize={props.size} />
);

SFEnergizeVideoIcon.propTypes = PROPS;
SFEnergizeVideoIcon.defaultProps = { DEFAULTPROPS };

export const SFEnergizeSummaryIcon = (props) => (
  <TextSnippetOutlinedIcon color={props.color} fontSize={props.size} />
);

SFEnergizeSummaryIcon.propTypes = PROPS;
SFEnergizeSummaryIcon.defaultProps = { DEFAULTPROPS };

export const SFMenuOpenIcon = (props) => (
  <MenuOpenIcon color={props.color} fontSize={props.size} />
);

SFMenuOpenIcon.propTypes = PROPS;
SFMenuOpenIcon.defaultProps = { DEFAULTPROPS };

export const SFTimerOutlinedIcon = (props) => (
  <TimerOutlinedIcon color={props.color} fontSize={props.size} {...props} />
);

SFTimerOutlinedIcon.propTypes = PROPS;
SFTimerOutlinedIcon.defaultProps = { DEFAULTPROPS };

export const SFRadioButtonCheckedIcon = (props) => (
  <RadioButtonCheckedIcon color={props.color} fontSize={props.size} />
);

SFRadioButtonCheckedIcon.propTypes = PROPS;
SFRadioButtonCheckedIcon.defaultProps = { DEFAULTPROPS };

export const SFRadioButtonUncheckedIcon = (props) => (
  <RadioButtonUncheckedIcon color={props.color} fontSize={props.size} />
);

SFRadioButtonUncheckedIcon.propTypes = PROPS;
SFRadioButtonUncheckedIcon.defaultProps = { DEFAULTPROPS };

export const SFExpandMoreIcon = (props) => {
  return <ExpandMore color={props.color} fontSize={props.size} />;
};

export const SFExpandLessIcon = (props) => {
  return <ExpandLess color={props.color} fontSize={props.size} />;
};

export const SFCreateNewFolderIcon = (props) => {
  return <CreateNewFolderIcon color={props.color} fontSize={props.size} />;
};

SFCreateNewFolderIcon.propTypes = PROPS;
SFCreateNewFolderIcon.defaultProps = { DEFAULTPROPS };

export const SFDriveFileMoveOutlinedIcon = (props) => {
  return (
    <DriveFileMoveOutlinedIcon color={props.color} fontSize={props.size} />
  );
};

SFDriveFileMoveOutlinedIcon.propTypes = PROPS;
SFDriveFileMoveOutlinedIcon.defaultProps = { DEFAULTPROPS };

export const SFUndoIcon = (props) => {
  return <UndoIcon color={props.color} fontSize={props.size} />;
};

SFUndoIcon.propTypes = PROPS;
SFUndoIcon.defaultProps = { DEFAULTPROPS };

export const SFPublishedWithChangesIcon = (props) => {
  return <PublishedWithChangesIcon color={props.color} fontSize={props.size} />;
};

SFPublishedWithChangesIcon.propTypes = PROPS;
SFPublishedWithChangesIcon.defaultProps = { DEFAULTPROPS };

export const SFSourceIcon = (props) => {
  return <SourceIcon color={props.color} fontSize={props.size} />;
};

export const SFLogoutIcon = (props) => {
  return <LogoutIcon color={props.color} fontSize={props.size} />;
};
SFLogoutIcon.propTypes = PROPS;
SFLogoutIcon.defaultProps = { DEFAULTPROPS };

SFSourceIcon.propTypes = PROPS;
SFSourceIcon.defaultProps = { DEFAULTPROPS };

export const SFSaveIcon = (props) => {
  return <SaveIcon color={props.color} fontSize={props.size} />;
};
SFSaveIcon.propTypes = PROPS;
SFSaveIcon.defaultProps = { DEFAULTPROPS };

export const SFLoopIcon = (props) => <LoopIcon {...props} />;

export const SFSpinnerIcon = (props) => <CircularProgress {...props} />;
SFSpinnerIcon.propTypes = PROPS;
SFSpinnerIcon.defaultProps = DEFAULTPROPS;

export const SFDoneIcon = (props) => <DoneIcon {...props} />;

export const SFTuneIcon = (props) => <TuneRoundedIcon {...props} />;

export const SFFilterListIcon = (props) => <FilterListRounded {...props} />;

export const SFRefreshIcon = (props) => <RefreshIcon {...props} />;

SFRefreshIcon.propTypes = PROPS;
SFRefreshIcon.defaultProps = DEFAULTPROPS;


export const SFMarkReviewedIcon = (props) => (
  <FactCheckOutlinedIcon {...props} />
);

SFMarkReviewedIcon.propTypes = PROPS;
SFMarkReviewedIcon.defaultProps = DEFAULTPROPS;

export const SFManageTaxonomyIcon = (props) => (
  <VerticalSplitOutlinedIcon {...props} />
);

SFManageTaxonomyIcon.propTypes = PROPS;
SFManageTaxonomyIcon.defaultProps = DEFAULTPROPS;

export const SFRateReviewOutlinedIcon = (props) => (
  <RateReviewOutlinedIcon {...props} />
);

SFRateReviewOutlinedIcon.propTypes = PROPS;
SFRateReviewOutlinedIcon.defaultProps = DEFAULTPROPS;

export const SFVerifiedUserOutlinedIcon = (props) => (
  <VerifiedUserOutlinedIcon {...props} />
);

SFVerifiedUserOutlinedIcon.propTypes = PROPS;
SFVerifiedUserOutlinedIcon.defaultProps = DEFAULTPROPS;

export const SFDeleteSweepOutlinedIcon = (props) => (
  <DeleteSweepOutlinedIcon {...props} />
);

SFDeleteSweepOutlinedIcon.propTypes = PROPS;
SFDeleteSweepOutlinedIcon.defaultProps = DEFAULTPROPS;

export const SFAppsIcon = (props) => <AppsIcon {...props} />;

SFAppsIcon.propTypes = PROPS;
SFAppsIcon.defaultProps = DEFAULTPROPS;

export const SFCopilotIcon = (props) => (
  <AutoAwesomeIcon {...props} fontSize={props.size} />
);

SFCopilotIcon.propTypes = PROPS;
SFCopilotIcon.defaultProps = DEFAULTPROPS;

export const SFDonutLargeIcon = (props) => <DonutLargeIcon {...props} />;

SFDonutLargeIcon.propTypes = PROPS;
SFDonutLargeIcon.defaultProps = DEFAULTPROPS;
export const SFMaximizeIcon = (props) => <MaximizeIcon {...props} />;

export const SFMinimizeIcon = (props) => <MinimizeIcon {...props} />;

export const SFGridOnIcon = (props) => (
  <GridOnIcon color={props.color} fontSize={props.size} {...props} />
);

export const SFGridViewIcon = (props) => <GridViewIcon {...props} />;

export const SFBookIcon = (props) => <BookIcon {...props} />;

export const SFAttachMoneyIcon = (props) => <AttachMoneyIcon {...props} />;

export const SFCallMergeIcon = (props) => <CallMergeIcon {...props} />;

export const SFTipsAndUpdatesOutlinedIcon = (props) => (
  <TipsAndUpdatesOutlinedIcon {...props} />
);

SFTipsAndUpdatesOutlinedIcon.propTypes = PROPS;
SFTipsAndUpdatesOutlinedIcon.defaultProps = DEFAULTPROPS;

export const SFOfflineBoltOutlinedIcon = (props) => (
  <OfflineBoltOutlinedIcon {...props} />
);

SFOfflineBoltOutlinedIcon.propTypes = PROPS;
SFOfflineBoltOutlinedIcon.defaultProps = DEFAULTPROPS;

export const SFSyncIcon = (props) => <SyncIcon {...props} />;

SFSyncIcon.propTypes = PROPS;
SFSyncIcon.defaultProps = DEFAULTPROPS;

export const SFSearchOffIcon = (props) => <SearchOffIcon {...props} />;

export const SFImageIcon = (props) => <ImageIcon {...props} />;

SFSearchOffIcon.propTypes = PROPS;
SFSearchOffIcon.defaultProps = DEFAULTPROPS;

export const SFFeaturedIcon = (props) => <TaskAltIcon {...props} />;

SFFeaturedIcon.propTypes = PROPS;
SFFeaturedIcon.defaultProps = DEFAULTPROPS;

export const SFMoveFileIcon = ({ size, ...restProps }) => (
  <DriveFileMoveIcon fontSize={size} {...restProps} />
);

SFMoveFileIcon.propTypes = PROPS;
SFMoveFileIcon.defaultProps = DEFAULTPROPS;

export const SFWorkOffOutlinedIcon = ({ size, ...restProps }) => (
  <WorkOffOutlinedIcon fontSize={size} {...restProps} />
);

SFWorkOffOutlinedIcon.propTypes = PROPS;
SFWorkOffOutlinedIcon.defaultProps = DEFAULTPROPS;

export const SFPendingOutlinedIcon = ({ size, ...restProps }) => (
  <PendingOutlinedIcon fontSize={size} {...restProps} />
);

SFPendingOutlinedIcon.propTypes = PROPS;
SFPendingOutlinedIcon.defaultProps = DEFAULTPROPS;
